export default __webpack_public_path__ + "static/media/Greenhouse_03.3e18f610.webp";